module.exports = [
  require('./list/grove_guardian'),
  require('./list/hound_of_ill_omen'),
  require('./list/tiny_servant'),
]
